<script>
	import "bootstrap-vue/dist/bootstrap-vue.css";
	import pagination from "vue-bootstrap-pagination";
	import schoolListView from "./SchoolListView.vue";
	import leftSideBar from "./LeftSideBar.vue";
	import districtButtons from "./DistrictButtons.vue";

	import * as mixin from "../secret/CryptoMaxin.vue";
	// import * as NotifyMixin from "../shared/NotifyMixin.vue";
	import * as detectMobileMixin from "../shared/detect-mobile-mixin.vue";
	import * as detectIEMixin from "../shared/detect-ie-mixin.vue";
	import * as CryptoJS from "crypto-js";

	// === 繁簡轉換 ===
	function getSiteLang() {
		const m = document.cookie.match(/site_lang=([^;]+)/);
		return m && m[1] === 'zh-Hans' ? 'zh-Hans' : 'zh-Hant';
	}
	const ZH_DEBUG = true;
	function zhLog() {
		if (!ZH_DEBUG) return;
		var args = Array.prototype.slice.call(arguments);
		args.unshift('[zh-mixin]');
		console.log.apply(console, args);
	}

	export default {
		// mixins: [mixin, NotifyMixin,detectMobileMixin,detectIEMixin],
		mixins: [mixin, detectMobileMixin, detectIEMixin],
		components: {
			pagination,
			"school-list-view": schoolListView,
			"left-side-bar": leftSideBar,
			"district-buttons":districtButtons
		},
		props: {
			level: "",
			district: "",
			financeType: "",
			ajaxFinanceType: "",
			keyword: "",
			category: ""
		},
		watch: {
			finishInit: "loadedKey",
			sortedBy: {
				handler: function(n, o) {
					// console.log("sortedBy, value", n);
				}
			},
			// === 繁簡轉換：pagedItems 變動後，重新掃描 DOM ===
			pagedItems: {
				handler() {
					zhLog('pagedItems changed, count=', this.pagedItems.length, 'siteLang=', this.siteLang);
					this.$nextTick(() => this.notifySwitcherRescan());
				},
				deep: true
			},
			siteLang(n, o) {
				zhLog('siteLang changed:', o, '->', n);
				// 切換器會透過 zh:langchange 事件自行處理，這裡不用做事
			}
		},
data() {
		return {
			mobile: false,
			display: "LIST",
			siteLang: 'zh-Hant',
			sessionKeys: {
				display: "kg-display",
				filter: "kg-filter",
				school: "kg-s"
			},
			sortedBy: null,
			showSideMenu: true,
			perPage: 20,
			total: 0,
			currentPage: 1,
			pagedItems: [],
			schools: [],
				schoolIndexLink: "",
				filteredItems: [],
				loading: false,
				districts: [],
				religious: [],
				financeTypes: [],
				genders: [],
				cachedPage: 1,
				isRestoreCache: false,
				filterMsg: "",
				isScrolling: false,
				model: {
					districts: [],
					religious: [],
					financeTypes: [],
					genders: [],
					keyword: ""
				},
				sortSeq: {
					資助種類: "asc",
					宗教: "asc",
					性別: "asc"
				}
			};
		},
		mounted() {
			zhLog('mounted, level=', this.level, 'window.OpenCC=', typeof window.OpenCC);
			this.$nextTick(() => {
				window.addEventListener("resize", () => {
					this.checkIsMobile();
				});
			});
			this.checkIsMobile();
			this.alertIE();
			this.loading = true;
			if (this.level == "幼稚園") this.schoolIndexLink = "/kg";
			if (this.level == "小學") this.schoolIndexLink = "/ps";
			if (this.level == "中學") this.schoolIndexLink = "/ss";

			// === 監聽切換器的語言變化事件 ===
			this.siteLang = getSiteLang();
			zhLog('initial siteLang =', this.siteLang);
			this._zhLangHandler = (e) => {
				zhLog('zh:langchange received, detail=', e.detail);
				this.siteLang = e.detail || getSiteLang();
			};
			window.addEventListener('zh:langchange', this._zhLangHandler);

			// === 若初始是簡體，等切換器就緒後主動觸發一次重掃 ===
			if (this.siteLang === 'zh-Hans') {
				this.$nextTick(() => this.notifySwitcherRescan());
			}

			// this.getMessage("SCHOOL", this.level, "LIST");
			this.super();
		},

		beforeDestroy() {
			if (this._zhLangHandler) {
				window.removeEventListener('zh:langchange', this._zhLangHandler);
			}
		},
	
methods: {
		// === 繁簡轉換：通知切換器重掃當前容器 ===
		notifySwitcherRescan() {
			zhLog('notifySwitcherRescan, switcher:', typeof window.__zhRescan);
			// 若切換器還沒載入，等它準備好再呼叫
			if (typeof window.__zhRescan === 'function') {
				window.__zhRescan();
			} else {
				zhLog('!! window.__zhRescan not available, wait for it');
				var self = this;
				var interval = setInterval(function() {
					if (typeof window.__zhRescan === 'function') {
						clearInterval(interval);
						zhLog('__zhRescan now available, calling');
						window.__zhRescan();
					}
				}, 100);
				// 最多等 10 秒
				setTimeout(function() {
					clearInterval(interval);
					zhLog('!! timeout waiting for __zhRescan');
				}, 10000);
			}
		},
		checkIsMobile() {
			this.mobile = this.isMobile();
			this.showSideMenu = !this.mobile;

			// console.log("run check is mobile", this.showSideMenu);
		},
			initKeys() {
				if (this.level == "小學") {
					this.sessionKeys.display = "ps-display";
					this.sessionKeys.filter = "ps-filter";
					this.sessionKeys.school = "ps-s";
				} else if (this.level == "中學") {
					this.sessionKeys.display = "ss-display";
					this.sessionKeys.filter = "ss-filter";
					this.sessionKeys.school = "ss-s";
				} else {
					this.sessionKeys.display = "kg-display";
					this.sessionKeys.filter = "kg-filter";
					this.sessionKeys.school = "kg-s";
				}
			},
			loadedKey() {
				this.initKeys();
	
				let self = this;
				let sd = sessionStorage.getItem(this.sessionKeys.display);
				if (sd != null) this.display = sd;
				let cacheItems = sessionStorage.getItem(this.sessionKeys.school);
				//   console.log("loaded key cacheItems", cacheItems);
				if (cacheItems) {
					this.decrypt_data(
						new Uint16Array(self.base64ToArrayBuffer(cacheItems))
					).then(
						function(result) {
							let decryptedData = self.convertArrayBufferViewtoString(
								new Uint16Array(result)
							);
							let tmp = JSON.parse(decryptedData);
							self.isRestoreCache = tmp.school_level == self.level;
							if (self.isRestoreCache) {
								self.model = tmp.model
								self.schools = tmp.schools;
								self.genders = tmp.genders;
								self.religious = tmp.religious;
								self.financeTypes = tmp.financeTypes;
								self.districts = tmp.districts;
								self.cachedPage = tmp.current_page;
								self.init();
							} else {
								self.fetchData();
							}
						},
						function(e) {
							// console.log("error message", e);
							self.fetchData();
						}
					);
				} else {
					self.fetchData();
				}
			},
			fetchData() {
				this.isRestoreCache = false;
				let url = "/api/school/getSchools/" + this.level;
				if(this.ajaxFinanceType){
					url += "?financeType=" + encodeURIComponent(this.ajaxFinanceType);
				}
				axios.get(url).then(res => {
					let decrypted = JSON.parse(
						CryptoJS.AES.decrypt(JSON.stringify(res.data), this.getPass(), {
							format: CryptoJSAesJson
						}).toString(CryptoJS.enc.Utf8)
					);
	
					this.schools = decrypted.data;
					
					// console.log("school data", this.schools);
					// let r = _.filter(this.schools,function(o) { return o.visitCampus.length>0; });
					// console.log("school",  r);
					
					this.religious = decrypted.metadata.宗教;
					this.financeTypes = decrypted.metadata.資助種類;
					this.genders = decrypted.metadata.就讀學生性別;
	
					axios.get(`/api/school/getLevelDistricts/${this.level}`).then(res => {
						this.districts = res.data;
						this.init();
					});
				});
			},
			storeStatus(target) {
				// console.log("store status", target);
				let self = this;
				// if(target == 'filter'){
				let data = {
					level: this.level,
					filters: this.model
				};
				sessionStorage.setItem(this.sessionKeys.filter, JSON.stringify(data));
				// }
	
				if (target == "schools") {
					let data = {
						model:this.model,					
						current_page: this.currentPage,
						school_level: this.level,
						religious: this.religious,
						financeTypes: this.financeTypes,
						genders: this.genders,
						districts: this.districts,
						schools: this.schools,
						create_datetime: moment()
					};
					data = JSON.stringify(data);
					this.encrypt_data(data).then(
						function(result) {
							// console.log("result plain text", result );
							let encryptedData = new Uint16Array(result);
							//  self.decrypt_data(encryptedData);
							var base64Data = self.arrayBufferToBase64(result);
							sessionStorage.setItem(self.sessionKeys.school, base64Data);
						},
						function(e) {
							console.log(e.message);
						}
					);
				}
			},
			refresh() {
				this.fetchData();
				this.reset();
			},
			reset() {
				sessionStorage.removeItem(this.sessionKeys.filter);
				this.prepareFilters();
				this.model= {
					districts: [],
					religious: [],
					financeTypes: [],
					genders: [],
					keyword: ""
				};
				this.filter();
				this.storeStatus("filter");
			},
			prepareFilters() {
				this.financeTypes.forEach(f => {
					this.model.financeTypes[f] = false;
				});
				this.model.financeTypes = Object.assign({}, this.model.financeTypes);
				this.religious.forEach(r => {
					this.model.religious[r] = false;
				});
				this.model.religious = Object.assign({}, this.model.religious);
				this.genders.forEach(g => {
					this.model.genders[g] = false;
				});
				this.model.genders = Object.assign({}, this.model.genders);
	
				this.districts.forEach(d => {
					this.model.districts[d] = false;
				});
				this.model.districts = Object.assign({}, this.model.districts);

				// search criteria was entered as prop,init the search filter
				if (this.keyword) {
					this.model.keyword = this.keyword;
				}
				if (this.financeType) {
					Vue.set(this.model.financeTypes, this.financeType, true);
				}
	
				if (this.district) {
					Vue.set(this.model.districts, this.district, true);
				}
				// this.filter();
			},
			init() {
				this.filteredItems = this.schools;
				// console.log("items", this.filteredItems);
				
				this.filteredItems = _.orderBy(
					// this.filteredItems, ["sort_to_top", "schoolBooksCount"], ["desc", "desc"]
					this.filteredItems, ["sort_scope"], ["desc", ]
				);
	
				let sFilter = sessionStorage.getItem(this.sessionKeys.filter);
				if (sFilter != null && this.isRestoreCache) {
					sFilter = JSON.parse(sFilter);
					this.model = sFilter.filters;
					this.settleParams();
					this.filter();							
					this.setPage(this.cachedPage, false);
					this.currentPage = this.cachedPage;
				} else {
					this.prepareFilters();				
					this.settleParams();
					this.filter();
					this.currentPage = 1;
					this.setPage(1, false);
				}
			},
	
			orderBy(col) {
				let sortSeq = this.sortSeq[col] == "asc" ? "desc" : "asc";
				this.sortSeq[col] = sortSeq;
				// console.log(this.sortSeq[col]);
				let temp = _.orderBy(this.filteredItems, col, this.sortSeq[col]);
				this.filteredItems = temp;

				this.currentPage = 1;
				this.setPage(1);
			},
			changeSortDirection(direction) {
				if (this.sortedBy) {
					let temp = _.orderBy(this.filteredItems, this.sortedBy, direction);
					this.filteredItems = temp;
					this.setPage(1);
				}
			},
			setSortFromView(col, direction) {
				this.sortedBy = col;
				this.sortSeq[col] = direction;
				let temp = _.orderBy(this.filteredItems, col, direction);
				this.filteredItems = temp;
				this.currentPage = 1;
				this.setPage(1);
			},
			settleParams(){
				if(this.district != ""){
					this.model.districts[this.district] = true;					
				}
				if(this.financeType != ""){
					this.model.financeTypes[this.financeType] = true;						
				}
				if(this.keyword != ""){
					this.model.keyword = this.keyword;
				}				
			},
			filter() {			
				this.filterMsg = "";
				let temp = this.schools;
	
				if (this.model.keyword) {
					if (this.filterMsg.indexOf(this.model.keyword) == -1) {
						this.filterMsg += ` ${this.model.keyword} `;
					}

					let keyword = this.model.keyword;

					if (/^\d+$/.test(keyword)) {
						temp = temp.filter(s => {
							return String(s.聯絡電話 || '').includes(keyword);
						});
					} else {
						var options = {
							shouldSort: true,
							findAllMatches: true,
							threshold: 0.3,
							location: 0,
							distance: 100,
							maxPatternLength: 100,
							minMatchCharLength: 1,
							keys: ["中文名稱", "english_name", "分區", "地址", "就讀學生性別"]
						};
						var fuse = new Fuse(temp, options);
						temp = fuse.search(keyword);
					}
					this.$delete(this.keyword);
				}
	
				if (this.isModified("religious")) {
					temp = temp.filter(s => {
						if (this.model.religious[s.宗教]) {
							return true;
						}
					});
					for (let idx in this.model.religious) {
						if (this.model.religious[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}
	
				if (this.isModified("financeTypes")) {
					temp = temp.filter(s => {
						if (this.model.financeTypes[s.資助種類]) {
							return true;
						}
					});
					for (let idx in this.model.financeTypes) {
						if (this.model.financeTypes[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
					this.$delete(this.financeType);
				}
	
				if (this.isModified("genders")) {
					temp = temp.filter(s => {
						if (this.model.genders[s.就讀學生性別]) {
							return true;
						}
					});
					for (let idx in this.model.genders) {
						if (this.model.genders[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
				}
	
				if (this.isModified("districts")) {
					// console.log("分區", temp);
					temp = temp.filter(s => {
						if (this.model.districts[s.分區]) {
							return true;
						}
					});
					for (let idx in this.model.districts) {
						if (this.model.districts[idx] && this.filterMsg.indexOf(idx) == -1)
							this.filterMsg += ` ${idx} `;
					}
	
					this.$delete(this.district);
				}
					
					temp = _.orderBy(temp, ["sort_scope"], ["desc"]);
				// temp = _.orderBy(temp, ["schoolBooksCount","sort_to_top"], ["desc", "desc"]);
				// console.log("order by ",temp, temp[0].sort_to_top, temp[0].schoolBooksCount);

				this.filteredItems = temp;
	
				this.storeStatus("filter");
	
				this.currentPage = 1;
				this.setPage(1, false);
			},
			isModified(col) {
				let modified = false;
				Object.keys(this.model[col]).forEach(prop => {
					if (this.model[col][prop]) modified = true;
				});
				return modified;
			},
			goTop(scroll = true) {
				if (!scroll) return;
				const header = document.querySelector('.school-list-header');
				if (header) {
					const top = header.offsetTop - 80;
					window.scrollTo({ top: top, behavior: 'smooth' });
				} else {
					window.scrollTo({ top: 0, behavior: 'smooth' });
				}
			},
			setPage(page, scroll = true) {
				this.loading = false;
				this.goTop(scroll);

				if (!page) {
					page = this.currentPage;
				}

				if (page < 1) {
					page = 1;
				}

				let pagination = this.getPager(
					this.filteredItems.length,
					page,
					this.perPage
				);

				if (pagination.totalPages > 0 && page > pagination.totalPages) {
					page = pagination.totalPages;
					pagination = this.getPager(
						this.filteredItems.length,
						page,
						this.perPage
					);
				}

				this.total = pagination.total;
				this.currentPage = pagination.current_page;

				this.pagedItems = this.filteredItems.slice(
					pagination.from,
					pagination.to
				);
			},
			getPager(totalItems, currentPage = 1, pageSize = 10) {
				let totalPages = Math.ceil(totalItems / pageSize);
	
				let from = 0,
					to = 0;
	
				from = currentPage * pageSize - pageSize;
				let remaining = totalItems % pageSize;
	
				if (currentPage == totalPages) {
					remaining > 0 ? (to = from + remaining) : (to = currentPage * pageSize);
				} else {
					to = currentPage * pageSize;
				}
	
				let pages = _.range(1, totalPages + 1);
				return {
					total: totalItems,
					current_page: currentPage,
					per_page: pageSize,
					totalPages: totalPages,
					from: from,
					to: to,
					startPage: currentPage,
					last_page: totalPages,
					pages: pages
				};
			}
		}
	};
</script>


// WEBPACK FOOTER //
// resources/js/school/SchoolListMixin.vue